import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../context/AdminAuthContext";

const ProtectedAdminRoute = ({ children }) => {
    const { isAdminAuthenticated } = useAdminAuth();

    if (!isAdminAuthenticated) {
        return <Navigate to="/funcard-admin-dashboard" replace />;
    }

    return children;
};

export default ProtectedAdminRoute;
